module.exports = {
  "metadata": {
    "width": "8",
    "height": "8",
    "name": "chevron-bottom"
  },
  "source": "<path d=\"M1.5 1L0 2.5l4 4 4-4L6.5 1 4 3.5 1.5 1z\"/>"
};